import { logout } from "../auth/logout";

function Navbar() {
  const role     = localStorage.getItem("role");
  const userName = localStorage.getItem("userName") || "User";

  if (!role) return null;

  const roleLabel = {
    ROLE_ADMIN:  "Administrator",
    ROLE_VENDOR: "Delivery Vendor",
    ROLE_USER:   "Subscriber",
  }[role] || "User";

  const roleClass = {
    ROLE_ADMIN:  "admin",
    ROLE_VENDOR: "vendor",
    ROLE_USER:   "user",
  }[role] || "user";

  return (
    <div className="topbar">
      <div className="topbar-title">
        {role === "ROLE_ADMIN"  && "Admin Dashboard"}
        {role === "ROLE_VENDOR" && "Vendor Dashboard"}
        {role === "ROLE_USER"   && "My Dashboard"}
      </div>

      <div className="topbar-right">
        <span className={`role-pill ${roleClass}`}>{roleLabel}</span>

        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "4px 10px", background: "var(--cream)",
          borderRadius: 20, border: "1px solid var(--border)"
        }}>
          <div style={{
            width: 26, height: 26, borderRadius: "50%",
            background: "linear-gradient(135deg, var(--gold), var(--gold-dark))",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 11, fontWeight: 700, color: "white"
          }}>
            {userName[0]?.toUpperCase()}
          </div>
          <span style={{ fontSize: 13, fontWeight: 500 }}>{userName}</span>
        </div>

        <button className="btn btn-outline btn-sm" onClick={logout}>
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default Navbar;
